<template>
   <div class="root">
   <img class="bgImage" src="../../assets/images/WaterSign_bg.jpg"/>
   <img class="logoImage" src="../../assets/images/WaterSign_logo.png" />
    <div class="viewBg" >
        <div class="topdiv">
            <span class="topdiv_left_Title">{{roomName }}</span>
            <div class="topdiv_right">
                <span class="topdiv_right_text1">{{timestamp |time }}</span>
                <span class="topdiv_right_text2">{{timestamp |date}}</span>
            </div>
        </div>
        <div class="bodyDiv">
            <div class="bodyDiv_left">
                <div v-if="useType==1" class="bodyDiv_left_1">
                    <div class="bodyDiv_left_1_top">
                        <span class="bodyDiv_left_1_span1">会议中…</span>
                        <img class="bodyDiv_left_1_topImage" src="../../assets/images/icon_WaterSign_underway.png" />
                    </div>
                    <span class="bodyDiv_left_1_span2">{{nowItem.theme}}</span>
                    <span class="bodyDiv_left_1_span3">{{nowItem.beginTime}}-{{nowItem.endTime}}</span>
                    <div class="bodyDiv_left_1_foot">
                        <span class="bodyDiv_left_1_span4">{{nowItem.userName}}</span>
                        <div  v-if="nowItem.department" class="bodyDiv_left_1_line"></div>
                        <span v-if="nowItem.department" class="bodyDiv_left_1_span5">{{nowItem.department}}</span>
                    </div>
                </div>
                <div v-if="useType==2" class="bodyDiv_left_2">
                    <img class="bodyDiv_left_2_Image" src="../../assets/images/icon_WaterSign_leisure.png" />
                    <span class="bodyDiv_left_2_span">会议室空闲~</span>
                </div>
                <div v-if="useType==3" class="bodyDiv_left_3">
                    <div class="bodyDiv_left_1_top">
                        <span class="bodyDiv_left_1_span1">即将召开</span>
                        <img class="bodyDiv_left_1_topImage" src="../../assets/images/icon_WaterSign_upcoming.png" />
                    </div>
                    <span class="bodyDiv_left_1_span2">{{nextItem.theme}}</span>
                    <span class="bodyDiv_left_1_span3">{{nextItem.beginTime}}-{{nextItem.endTime}}</span>
                    <div class="bodyDiv_left_1_foot">
                        <span class="bodyDiv_left_1_span4">{{nextItem.userName}}</span>
                        <div  v-if="nextItem.department" class="bodyDiv_left_1_line"></div>
                        <span v-if="nextItem.department" class="bodyDiv_left_1_span5">{{nextItem.department}}</span>
                    </div>
                </div>
                <div v-if="useType==4" class="bodyDiv_left_3">
                    <div class="bodyDiv_left_4_top">
                        <div class="bodyDiv_left_4_top_left">
                            <img class="bodyDiv_left_4_topImage" src="../../assets/images/icon_WaterSign_notice.png" />
                            <span class="bodyDiv_left_4_span1">已到会议时间，超时开门</span>
                        </div>
                        <span class="bodyDiv_left_4_span2">{{this.tStr}}</span>
                    </div>
                    <span class="bodyDiv_left_1_span2">{{nowItem.theme}}</span>
                    <span class="bodyDiv_left_1_span3">{{nowItem.beginTime}}-{{nowItem.endTime}}</span>
                    <div class="bodyDiv_left_1_foot">
                        <span class="bodyDiv_left_1_span4">{{nowItem.userName}}</span>
                        <div v-if="nowItem.department" class="bodyDiv_left_1_line"></div>
                        <span  v-if="nowItem.department" class="bodyDiv_left_1_span5">{{nowItem.department}}</span>
                    </div>
                </div>
                <div v-if="useType==5" class="bodyDiv_left_5">
                    <div class="bodyDiv_left_5_top">
                        <div class="bodyDiv_left_5_top_left">
                            <img class="bodyDiv_left_5_topImage" src="../../assets/images/icon_WaterSign_sunderway.png" />
                            <span class="bodyDiv_left_5_span1">会议中…</span>
                        </div>
                        <span class="bodyDiv_left_5_span2">{{nowItem.beginTime}}-{{nowItem.endTime}}</span>
                    </div>
                    <div class="bodyDiv_left_5_body">
                        <span class="bodyDiv_left_5_span3">{{nowItem.theme}}</span>
                        <span class="bodyDiv_left_5_span4">{{nowItem.userName}}</span>
                    </div>
                </div>
                <div v-if="useType==5" class="bodyDiv_left_6">
                    <div class="bodyDiv_left_5_top">
                        <div class="bodyDiv_left_5_top_left">
                            <!--  -->
                            <img class="bodyDiv_left_5_topImage"  src="../../assets/images/icon_WaterSign_supcoming.png" />
                            <span class="bodyDiv_left_5_span1">即将召开</span>
                        </div>
                        <span class="bodyDiv_left_5_span2">{{nextItem.beginTime}}-{{nextItem.endTime}}</span>
                    </div>
                    <div class="bodyDiv_left_5_body">
                        <span class="bodyDiv_left_5_span3">{{nextItem.theme}}</span>
                        <span class="bodyDiv_left_5_span4">{{nextItem.userName}}</span>
                    </div>
                </div>
            </div>
            <div class="bodyDiv_right">
                <span class="bodyDiv_right_title">会议列表</span>
                <div class="bodyDiv_right_table">
                    <span class="bodyDiv_right_table_span1 tableText">日期</span>
                    <span class="bodyDiv_right_table_span2 tableText">时间</span>
                    <span class="bodyDiv_right_table_span3 tableText">会议主题</span>
                    <span class="bodyDiv_right_table_span4 tableText">组织者</span>
                </div>
                <div class="bodyDiv_right_line"></div>
                <div class="bodyDiv_right_list" v-if="meettingList.length>0">
                        <scroll class="scroll" :pullup="false" :pulldown="false" >
                            <section  class="list_cell" v-for="(item,index) in meettingList" :key="index"  >
                                <span class="bodyDiv_right_table_span1 listText">{{item.dayStr}}</span>
                                <span class="bodyDiv_right_table_span2 listText" >{{item.beginTime}}-{{item.endTime}}</span>
                                <span class="bodyDiv_right_table_span3 listText">{{item.theme}}</span>
                                <span class="bodyDiv_right_table_span4 listText">{{item.userName}}</span>
                            </section>
                        </scroll>
                </div>
                <div class="bodyDiv_right_nodata" v-if="meettingList.length==0">
                    <span class="bodyDiv_right_span">还没有预订~</span>
                </div>
            </div>
        </div>
        <div class="footDiv">
            <div class="footDivSediv">
                <div v-for="(item,index) in valueList" :key="index" class="footDivSediv_item" >
                    <!-- <div v-if="index ==0 &&item ==1" class="footDivSediv_item_line"></div>
                    <div v-if="index !=0 &&item ==1 &&valueList[index-1]===0" class="footDivSediv_item_line"></div> -->
                    <div v-if="item==1" class="footDivSediv_item2"></div>
                    <div v-else class="footDivSediv_item1"></div>
                    <!-- <div v-if="index ==(valueList.length-1) &&item ==1" class="footDivSediv_item_line"></div>
                    <div v-if="index !=(valueList.length-1) &&item ==1 &&valueList[index+1]!=1" class="footDivSediv_item_line"></div> -->
                </div>
            </div>
            <div class="footDivTimediv">
                <span v-for="(item,index) in timeList" :key="index" class="footDivTimediv_item" >{{item}}
                </span>

            </div>
        </div>
    </div>
   </div>
</template>

<script>
import util from "../../utils/util";
import Scroll from "../../components/scroll";
import {getMeetingOrderListByRoomNo } from "../../utils/api";

export default {
    name:'WaterSign',
    components: {
     Scroll,
  },
    data(){
      return {
        valueList:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
        roomStatus:[],
        bg_image:require("../../assets/images/WaterSign_bg.jpg"),
        useType:2, //当前使用状态
        viewWidth:0,
        viewHeight :0,
        timestamp:'',
        timer:'',
        year:'',
        month:'',
        day:'',
        hour:'',
        minute:'',
        second :'',
        activeDate:'',
        meetTingB:0,
        meettingID:'', //MR2202004090015
        meettingList:[],
        roomName:'',
        nowItem :'', //当前会议
        nextItem:'', //下一个会议
        timeList:['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'],
        //valueList:[0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
        timer1:'',
        tStr:'',
      }
    },

    filters: {
       date: function (value) {
            if(!value){
                return '';
            }
            return util.formatTime(new Date(value), 25)
       },
       time: function (value) {
           if(!value){
                return '';
           }
           return util.formatTime(new Date(value),22)
       },
    },
    created(){
        this.viewWidth = window.outerWidth;
        this.viewHeight= window.outerHeight;
        let query = this.$route.query;
        this.meettingID = query.meettingID;
        this.getMeetingOrderlistByRoomNo();

        this.timeAction();
    },
    beforeDestroy() {
        if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
            clearInterval(this.timer); //关闭
        }
         if(this.timer1) { //如果定时器还在运行 或者直接关闭，不用判断
            clearInterval(this.timer1); //关闭
        }
    },

    methods: {
        timeAction(){
           clearInterval(this.timer);
           this.timer = setInterval(()=>{
               console.log("in timeAction")
               this.getMeetingOrderlistByRoomNo()
             },60*1000)
        },

        getMeetingOrderlistByRoomNo(){

            let params = {
              'roomNo': this.meettingID
            }
          this.allPayAmount =0;
          this.isChouse=false;
          getMeetingOrderListByRoomNo(params).then(res => {
            this.timestamp =res.res.timestamp;
            if (res.res.code === 10000 && res.body) {
                clearInterval(this.timer1);
                this.roomName =res.body.roomName
                var tdate = new Date(this.timestamp)
                this.year = tdate.getFullYear();
                this.month = tdate.getMonth() + 1;
                this.day = tdate.getDate();
                this.hour = tdate.getHours();
                this.minute = tdate.getMinutes();
                this.second = tdate.getSeconds();
                this.activeDate = this.year+':'+this.month+":"+this.day;
                this.nowItem='';
                this.nextItem='';
                this.roomStatus = res.body.roomStatus;
                console.log(this.roomStatus.length);
                if(this.roomStatus.length==48){
                    var rlist =[];
                    var nowI =0;
                    nowI= this.hour*2;
                    if(this.minute>=30){
                        nowI=nowI+1;
                    }
                    for(var i=16;i<16+28;i++){
                        var v =0;
                        var vi =  this.roomStatus[i];
                        var v1 =   this.roomStatus[i+1];
                        if(vi ==0 &&v1==0){
                            v= 0;
                        }else if(vi ==0 && v1==1){
                            v=1;
                        } else if(vi==1 &&v1==0){
                            console.log('nowI == ' +nowI + ' && i == ' +i)
                            if(nowI ==i){
                                v=1;
                            }else{
                                v=0;
                            }

                        }else if(vi==1 &&v1==1){
                            v=1;
                        }
                        rlist.push(v);
                    }
                    this.valueList =rlist;

                }
                var list = res.body.meetingOrderList;
                for(var i=0;i<list.length;i++){
                    var item =list[i];
                    var iBdate =new Date(item.payDate+" "+ item.beginTime);
                    var ibyear = iBdate.getFullYear();
                    var ibmonth = iBdate.getMonth() + 1;
                    var ibday = iBdate.getDate();
                    // var ibhour = iBdate.getHours();
                    // var ibminute = iBdate.getMinutes();
                    if(this.year == ibyear && this.month ==ibmonth && this.day == ibday){
                         item.dayStr ="今天";
                         var iedate =new Date(item.payDate+" "+ item.endTime);
                         var str = this.timestamp - iBdate;
                         var str1 = this.timestamp - iedate;
                         console.log("iBdate == " + JSON.stringify(str))
                         console.log("iBdate == " + JSON.stringify(str1))
                         if(str>0 &&str1<0){
                             this.nowItem =item;
                             this.meetTingB=str;
                             console.log( "nowItem");
                         }else if(str<0 && str>-30*60*1000){
                             this.nextItem =item;
                              console.log( "nextItem");
                         }
                    }else if(this.year == ibyear && this.month ==ibmonth && this.day == ibday-1 ){
                         item.dayStr ="明天";
                    }else{
                         item.dayStr =ibmonth+'-'+ibday;
                    }
                    console.log("iBdate == " + JSON.stringify(iBdate))
                }
                this.meettingList = list;
                if(this.nowItem && this.nextItem ){
                    this.useType =5;
                }else if(this.nowItem){
                    if(this.nowItem.hxStatus==0){
                        this.useType=4
                        this.timer1 =setInterval(()=>{
                            console.log("in changeTime")
                            this.changeTime()
                         },1*1000)
                    }else{
                        this.useType=1;
                    }
                }else if(this.nextItem){
                    this.useType=3
                    console
                }else{
                    this.useType =2;
                }
            }else{
               util.showToast(res.res.msg);
            }
         });

        },
        changeTime(){
            this.meetTingB =this.meetTingB+1000;
            var hour = parseInt(this.meetTingB/(60*60*1000));
            var ss = this.meetTingB%(60*60*1000);
            var s = parseInt(ss/(60*1000));
            var mm = ss%(60*1000);
            var m = parseInt(mm/1000);
            var hoursrt ='';
            if(hour<10){
                hoursrt ='0'+hour;
            }else{
                hoursrt = hour;
            }
            var ssrt ='';
            if(s<10){
                ssrt ='0'+s;
            }else{
                ssrt = s;
            }
            var msrt ='';
            if(m<10){
                msrt ='0'+m;
            }else{
                msrt = m;
            }
            this.tStr = hoursrt+':'+ssrt+':'+msrt;
        },

    } ,
}
</script>
<style lang="less" scoped>
.root{
    width: 100%;
   height: 100%;
   position: relative;
}
.bgImage{
    width: 100%;
    height: 100%;
    z-index: 1;
    position:absolute;
}
.logoImage{
     top: 6.25vh;
     left: 6.26vh;
     width: 26vh;
     height: 3.375vh;
     z-index: 1;
    position:absolute;
}
.viewBg{
   width: 100%;
   height: 100%;
   z-index: 11;
   position:absolute;
//    background-color: red;
//    display: flex;
   flex-direction: column;
}
.topdiv{
    width: 100%;
    height:16.62vh ;
    margin-top:7.5vh ;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.topdiv_left_Title{
    margin-left:3.9vw ;
    font-size:8.25vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:11.5vh;
}

.topdiv_right{
    margin-right: 3.9vw;
    flex-direction: column;
    display: flex;
    justify-content: right;
}
.topdiv_right_text1{
    text-align: right;
    font-size:11.62vh;
    font-weight:300;
    color:rgba(255,255,255,1);
    line-height:11.62vh;
}
.topdiv_right_text2{
    margin-top: 1.62vh;
    text-align: right;
    font-size:3.25vh;
    font-weight:300;
    color:rgba(255,255,255,1);
    line-height:4.62vh;
}

.bodyDiv{
    width: 100%;
    height:55vh ;
    margin-top:7.5vh ;
    // background-color: blue;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

}
.bodyDiv_left{
     margin-left:3.12vw ;
     width:45.3vw;
     height:55vh;
     flex-direction: column;
    // background-color: orange;
}

.bodyDiv_left_1{
     display: flex;
     width:45.3vw;
     height:55vh;
     background:linear-gradient(270deg,rgba(253,171,56,1) 0%,rgba(255,125,0,1) 100%);
     border-radius:27px;
     flex-direction: column;
}
.bodyDiv_left_1_top{
    margin-top: 5vh;
    flex-direction: row;
     width:45.3vw;
     height: 10vh;
     display: flex;
    justify-content: space-between;

    align-items: center;
    // padding-left: 3.12vw;
    // padding-right: 3.12vw;
}
.bodyDiv_left_1_span1{
    margin-left: 3.12vw ;
    font-size:4.625vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:6.5vh;
}
.bodyDiv_left_1_topImage{
    margin-right: 3.12vw ;
    width: 10vh;
    height: 10vh;
}
.bodyDiv_left_1_span2{
    margin-left: 3.12vw ;
    margin-right: 3.12vw ;
    margin-top: 5.5vh;
    font-size:5.75vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:8.12vh;
}
.bodyDiv_left_1_span3{
    margin-left: 3.12vw ;
    margin-right: 3.12vw ;
    margin-top: 2.5vh;
    font-size:4.25vh;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:6vh;
}
.bodyDiv_left_1_foot{
    margin-top: 1.25vh;
    flex-direction: row;
     width:45.3vw;
     height: 10vh;
     display: flex;
    justify-content: flex-start;
    align-items: center;

}
.bodyDiv_left_1_span4{
    margin-left: 3.12vw ;
    font-size:3.25vh;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:4.62vh;
}
.bodyDiv_left_1_line{
    margin-left: 1.56vw ;
    margin-right: 1.56vw ;
    width:2px;
    height:4.62vh;
    background:rgba(255,255,255,1);
    opacity:0.5;
}
.bodyDiv_left_1_span5{

    font-size:3.25vh;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:4.62vh;
}

.bodyDiv_left_2{
    width:45.3vw;
    height:55vh;
    background:rgba(22,188,132,1);
    border-radius:27px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.bodyDiv_left_2_Image{
    width: 10vh;
    height: 10vh;
}
.bodyDiv_left_2_span{
    margin-top: 3.75vh;
    font-size:4.75vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:6.62vh;
}
.bodyDiv_left_3{
    background:rgba(80,95,255,1);
    display: flex;
     width:45.3vw;
     height:55vh;
     border-radius:27px;
     flex-direction: column;
}
.bodyDiv_left_4_top{
    width:45.3vw;
    display: flex;
    height:15vh;
    background:linear-gradient(270deg,rgba(253,171,56,1) 0%,rgba(255,125,0,1) 100%);
    border-radius:27px 27px 0px 0px;
    align-items: center;
    justify-content: space-between;
}
.bodyDiv_left_4_top_left{
    display: flex;
    margin-left: 3.75vh;
    flex-direction: row;
}
.bodyDiv_left_4_topImage{
    width: 5.37vh;
    height: 5.37vh;
}
.bodyDiv_left_4_span1{
    margin-left: 1.75vh;
    font-size:3.25vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:6vh;
}
.bodyDiv_left_4_span2{
    margin-right: 3.75vh;
    font-size:4.25vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:6vh;
}

.bodyDiv_left_5{
    display: flex;
    width:45.3vw;
    height:25vh;
    background:linear-gradient(270deg,rgba(253,171,56,1) 0%,rgba(255,125,0,1) 100%);
    border-radius:27px;
    flex-direction: column;
}
.bodyDiv_left_6{
    margin-top: 5vh;
    display: flex;
    width:45.3vw;
    height:25vh;
    background:rgba(80,95,255,1);
    border-radius:27px;
    flex-direction: column;
}
.bodyDiv_left_5_top{
    margin-top: 2.25vh;
    align-items: center;
    display: flex;
    justify-content: space-between;
    width:45.3vw;
    height:11.25vh;
}
.bodyDiv_left_5_top_left{
    // background-color: red;
    display: flex;
    align-items: center;
    margin-left: 3.75vh;
    flex-direction: row;
}
.bodyDiv_left_5_topImage{
    // background-color: blue;
     width: 5.75vh;
    height: 5.75vh;
    margin-right: 8px;
}
.bodyDiv_left_5_span1{
    font-size:4vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:6vh;
}
.bodyDiv_left_5_span2{
    margin-right: 3.75vh;
    font-size:4vh;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:6vh;
}
.bodyDiv_left_5_body{
    align-items: center;
    display: flex;
    justify-content: space-between;
    width:45.3vw;
}
.bodyDiv_left_5_span3{
    margin-left: 3.75vh;
    font-size:4.62vh;
    font-weight:500;
    width: 50vh;
    color:rgba(255,255,255,1);
    line-height:6.5vh;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.bodyDiv_left_5_span4{
    margin-top: 1.87vh;
    margin-right: 3.75vh;
    font-size:3.25vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:4.62vh;
}

.bodyDiv_right{
     margin-right:3.12vw ;
     width:45.3vw;
     height:55vh;
     display: flex;
     flex-direction: column;
     background:rgba(0,0,0,0.5);
     border-radius:27px;
}
.bodyDiv_right_title{
    margin-top:3.75vh ;
    margin-left:3.75vh ;
    font-size:3.25vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:4.62vh;
}
.bodyDiv_right_table{
    flex-direction: row;
    margin-top:3.25vh ;
    margin-left:3.75vh ;
    width:42.8vw;
    display: flex;
}
.bodyDiv_right_table_span1{
    width: 6.56vw;
    display: flex;
    font-size:2.75vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:3.75vh;
}

.bodyDiv_right_table_span2{
    width: 12.5vw;
    display: flex;
    font-size:2.75vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:3.75vh;
}
.bodyDiv_right_table_span3{
    width: 15.8vw;
    // display: flex;
    font-size:2.75vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:3.75vh;
}
.bodyDiv_right_table_span4{
    width: 6.56vw;
    display: flex;
    font-size:2.75vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:3.75vh;
}
.tableText{
     color:rgba(255,255,255,0.7);
}
.bodyDiv_right_line{
    width: 100%;
    height: 1px;
    display: flex;
    margin-top:2vh ;
    background:rgba(255,255,255,0.2);
}
.bodyDiv_right_nodata{
    width: 100%;
    flex-direction: column;
    height:37.5vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.bodyDiv_right_span{
    font-size:3.25vh;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,0.5);
    line-height:4.625vh;
    margin-bottom: 5vh;
}
.bodyDiv_right_list{
    width: 100%;
    flex-direction: column;
    height:37.5vh;
    display: flex;
}
.scroll{
     flex: 1;
     height: 500px;
     margin-bottom: 5vh;
}
.list_cell{
    flex-direction: row;
    margin-top:4.37vh ;
    margin-left:3.75vh ;
    width:42.8vw;
    display: flex;
}
.listText{
     font-size:2.37vh;
     color:rgba(255,255,255,1);
     line-height:3.25vh;
     white-space: nowrap;
     overflow: hidden;
    text-overflow: ellipsis;
}


.footDiv{
    width: 100%;
    height:7.5vh ;
    margin-top:5.8vh ;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    position: relative;
}
.footDivSediv{
    margin-left: 4.922vw;
    // width: 96vw;
    flex-direction: row;
    display: flex;
    align-items: center;
}
.footDivSediv_item_line{
    width: 2px;
    height: 4.25vh;
    background:rgba(22,188,132,1);
}
.footDivSediv_item{
    display: flex;
    align-items: center;
    flex-direction: row;
}
.footDivSediv_item1{
    height: 3.75vh;
    width: 3.2125vw;
    display: flex;
}
.footDivSediv_item2{
    height: 3.75vh;
    background-color: rgba(22,188,132,0.5);
    display: flex;
    width: 3.2vw;
}
.footDivTimediv{
    left: 3.125vw;
    top: 2.25vh;
    width: 93.75vw;
    display: flex;
    position: absolute;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}
.footDivTimediv_item{
    margin-top: 2px;
    font-size:2.125vh;
    text-align: center;
    font-weight:500;
    width: 5.75vh;
    // background-color: red;
    color:rgba(255,255,255,1);
    line-height:3vh;
    // margin-right:3vw ;
}


</style>